import type { LucideIcon } from "lucide-react";

interface GuestCatalogSectionHeaderProps {
  title: string;
  icon?: LucideIcon;
  description?: string;
  action?: React.ReactNode;
}

export function GuestCatalogSectionHeader({
  title,
  icon: Icon,
  description,
  action,
}: GuestCatalogSectionHeaderProps) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          {Icon ? <Icon className="h-5 w-5 shrink-0 text-primary" aria-hidden /> : null}
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        </div>
        {description ? <p className="text-sm text-gray-500">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
